import { render, staticRenderFns } from "./ManageTransactionsNewReport.vue?vue&type=template&id=688c5364"
import script from "./ManageTransactionsNewReport.vue?vue&type=script&lang=js"
export * from "./ManageTransactionsNewReport.vue?vue&type=script&lang=js"
import style0 from "./ManageTransactionsNewReport.vue?vue&type=style&index=0&id=688c5364&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports